import { useEffect, useState } from "react";
import axios from "axios";
import { RefreshCw } from "lucide-react";
import { API } from "../lib/apiClient";
import { DeliverySparkline } from "./DeliverySparkline";

export function EmailLogsPanel() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [filter, setFilter] = useState("all");
  const fetchLogs = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/email-logs?limit=50`);
      setLogs(data || []);
      setError("");
    } catch (e) {
      setError(e?.response?.data?.detail || e?.message || "Yüklenemedi");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { fetchLogs(); }, []);
  const fmt = (iso) => {
    if (!iso) return "—";
    try { return new Date(iso).toLocaleString("tr-TR", { dateStyle: "short", timeStyle: "short" }); } catch { return iso; }
  };
  const KIND_LABEL = { reset: "Şifre sıfırlama", renewal: "Yenileme hatırlatması", backup: "Haftalık yedek", monthly: "Aylık özet", test: "Deneme e-postası", quote: "Teklif maili", other: "Diğer" };
  const STATUS_LABEL = { cancelled: "İptal edildi", queued: "Sırada (yeniden denenecek)", pending: "Beklemede", sent: "Gönderildi", delivered: "Teslim edildi", bounced: "Geri döndü", complained: "Spam şikayeti", failed: "Başarısız", opened: "Açıldı", clicked: "Tıklandı", delayed: "Gecikti" };
  const STATUS_TONE = { sent: "sent", delivered: "ok", opened: "ok", clicked: "ok", bounced: "danger", failed: "danger", complained: "danger", delayed: "warning", pending: "warning" };
  const filtered = filter === "all" ? logs : logs.filter(l => (l.kind || "other") === filter);
  return (
    <div className="email-logs-panel" data-testid="email-logs-panel" style={{ marginTop: 18 }}>
      <div className="email-logs-head">
        <div>
          <h3 style={{ margin: 0, font: "700 14px 'Plus Jakarta Sans'" }}>E-posta teslim kayıtları</h3>
          <p className="muted" style={{ fontSize: 11, margin: "4px 0 0" }}>Son 50 gönderim. Resend webhook bağlıysa teslim/bounce/spam durumları otomatik güncellenir.</p>
        </div>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <select data-testid="email-logs-filter" value={filter} onChange={(e) => setFilter(e.target.value)} style={{ padding: "6px 8px", border: "1px solid var(--line)", borderRadius: 6, fontSize: 12 }}>
            <option value="all">Tümü</option>
            <option value="backup">Yedek</option>
            <option value="renewal">Yenileme</option>
            <option value="quote">Teklif</option>
            <option value="reset">Şifre sıfırlama</option>
          </select>
          <button className="text-button" onClick={fetchLogs} data-testid="email-logs-refresh"><RefreshCw size={13} /> Yenile</button>
        </div>
      </div>
      {loading ? <p className="muted" style={{ fontSize: 12 }}>Yükleniyor…</p> :
       error ? <p style={{ color: "#dc2626", fontSize: 12 }}>{error}</p> :
       <>
         <DeliverySparkline logs={logs} />
         {filtered.length === 0 ?
           <p className="muted" style={{ fontSize: 12, padding: "12px 0" }}>Henüz kayıt yok. Her e-posta gönderimi burada görünecek.</p> :
           <div className="table-scroll" style={{ marginTop: 10 }}>
             <table data-testid="email-logs-table">
               <thead><tr><th>Tarih</th><th>Alıcı</th><th>Konu</th><th>Tür</th><th>Durum</th></tr></thead>
               <tbody>
                 {filtered.map((l) => (
                   <tr key={l.id} data-testid={`email-log-${l.id}`}>
                     <td>{fmt(l.createdAt)}{l.updatedAt && l.updatedAt !== l.createdAt && <small>güncel: {fmt(l.updatedAt)}</small>}</td>
                     <td>{l.to}{Array.isArray(l.cc) && l.cc.length > 0 && <small>+ {l.cc.join(", ")}</small>}</td>
                     <td style={{ whiteSpace: "normal", maxWidth: 300 }}>{l.subject}{l.errorDetail && <small style={{ color: "#dc2626" }}>{l.errorDetail}</small>}</td>
                     <td>{KIND_LABEL[l.kind] || l.kind}</td>
                     <td><span className={`email-status email-status-${STATUS_TONE[l.status] || "warning"}`} data-testid={`email-log-status-${l.id}`}>{STATUS_LABEL[l.status] || l.status}</span></td>
                   </tr>
                 ))}
               </tbody>
             </table>
           </div>
         }
       </>
      }
    </div>
  );
}
